import { render, staticRenderFns } from "./SellerNotResponding.vue?vue&type=template&id=50b2b0ba&scoped=true"
import script from "./SellerNotResponding.vue?vue&type=script&lang=js"
export * from "./SellerNotResponding.vue?vue&type=script&lang=js"
import style0 from "./SellerNotResponding.vue?vue&type=style&index=0&id=50b2b0ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2b0ba",
  null
  
)

export default component.exports